import React from 'react'
import { Route, useHistory } from 'react-router-dom'

import PrivateRoute from 'src/components/Router/PrivateRoute'

export default function AclRoute({ features, path, feature, isPrivate = false, component }) {
  const history = useHistory()
  const nestedRoutes = ['user', 'users', 'contact']
  let foundedFeature
  if (features && feature && !nestedRoutes.includes(feature)) {
    foundedFeature = features.find(f => f.id === feature)
    if (foundedFeature && !foundedFeature.isEnabled) {
      history.push('/welcome')
      return <></>
    }
  }

  if (isPrivate || (foundedFeature && foundedFeature.settings.isLoginRequired)) {
    return <PrivateRoute path={path} component={component} />
  }

  return <Route path={path} component={component} />
}
